import { StylePanelProps } from '@/lib/stylePanel'
import useResponsivePadding from '@/lib/useResponsivePadding'

import { PhnxSectiontitle } from '../../01-atoms/Sectiontitle/Sectiontitle'
import styles from './Imagecardgrid.module.css'
export type ImagecardgridProps = {
  title: string
  description: string
  items: React.ReactNode
} & StylePanelProps

export const PhnxImagecardgrid: React.FC<ImagecardgridProps> = ({
  title,
  description,
  items,
  padding,
  backgroundColor,
  textColor,
  alignment = 'center',
}) => {
  const paddingStyles = useResponsivePadding(padding)

  const style = {
    ...paddingStyles,
    backgroundColor,
    color: textColor,
  }

  return (
    <div style={style} className="stylepanel">
      {}
      <style jsx>{`
        stylepanel {
          ${paddingStyles}
        }
      `}</style>
      <div className={`${styles['imagecardgrid']} ${styles[`alignment-${alignment}`]} container`}>
        <div className={styles.content}>
          <PhnxSectiontitle
            title={title ? title : ''}
            subtitle={description ? description : ''}
            variant={'quaternary'}
          />

          {/* {title && (
            <div className={`${styles.title} title`}>
              <h2>{title}</h2>
            </div>
          )}
          {description && (
            <div className={styles.description}>
              <p>{description} </p>
            </div>
          )} */}
        </div>
        {items && <div className={styles['grid-container']}>{items}</div>}
      </div>
    </div>
  )
}
